module.exports = __webpack_public_path__ + "static/sound/stepR1.7e4b83861.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/fx/steps/stepR1.mp3
// module id = 474
// module chunks = 1